// especially useful for route loaders and other non-react async code
// for keyed data that we want to cache and typically request once
export function createKeyedAsyncCache<K, V>(load: (key: K) => Promise<V>) {
  const values = new Map<K, V>();
  const pending = new Map<K, Promise<V>>();

  return {
    getCurrent(key: K): V | undefined {
      return values.get(key);
    },

    async get(key: K, force = false): Promise<V> {
      if (values.has(key) && !force) {
        return values.get(key)!;
      }

      if (pending.has(key) && !force) {
        return pending.get(key)!;
      }

      const request = load(key)
        .then((value) => {
          values.set(key, value);
          return value;
        })
        .finally(() => {
          pending.delete(key);
        });

      pending.set(key, request);

      return request;
    },

    clear(key?: K) {
      if (key === undefined) {
        values.clear();
        pending.clear();
      } else {
        values.delete(key);
        pending.delete(key);
      }
    },
  };
}
